// extracted by mini-css-extract-plugin
module.exports = {"navHostTag":"style_navHostTag__1P0PY","homeHostTag":"style_homeHostTag__xL_cS","modalBtn":"style_modalBtn__xqWAo","light":"style_light__ETosi","dark":"style_dark__zQV_q"};